import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import companyApi from '@/features/dashboard/company/api/companyApi.ts';
import { companyApiQueryKeys } from '@/features/dashboard/company/api/companyApi.queryKeys.ts';
import CompanyInfoDto from '@/features/dashboard/company/types/CompanyInfoDto.ts';

const useGetCompanyInfo = () => {
  return useQuery(getCompanyInfoQueryOptions());
};

export const getCompanyInfoQueryOptions =
  (): UseQueryOptions<CompanyInfoDto> => ({
    queryKey: companyApiQueryKeys.companyInfo(),
    queryFn: () => companyApi.getCompanyInfo(),
    staleTime: 1000 * 60,
  });

export default useGetCompanyInfo;
